<template>
  <div>
    <h1>Comming Soon...</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
